import withValidation from "./withValidation.js";
import Check from "./Check.js";

export default withValidation(Check);
